import { Reducer } from "redux";
import { StatusType, IStatus } from "..";
import { StatusAction } from "../actions";

export const StatusReducer: Reducer<IStatus> = (state: IStatus = {type: StatusType.READY, statusMessage: ""}, action: StatusAction) => {
    if(action.status) {
        return action.status;
    }
    return state;
}